<template>
  <Block :badge-class="statusClassBg" :emoji="statusEmoji">
    <template #title>
      <h3 class="text-xl font-bold tracking-tight text-black">
        <template v-if="reachedTier">
          Palier {{ reachedTier.tier }} atteint (+{{ multiplierPercentage(reachedTier.multiplicator) }}%)
        </template>
        <template v-else>
          Aucun palier atteint
          <span class="text-xs text-gray-600" v-if="nextTier">
            ({{ $t("roadmap.sales", nextTier.threshold - current) }} restantes pour +
            {{ multiplierPercentage(nextTier.multiplicator) }}%)
          </span>
        </template>
      </h3>
    </template>
    <template #subtitle>
      <h3
        v-if="projectionTier && (!reachedTier || projectionTier.threshold > reachedTier.threshold)"
        class="text-lg font-medium tracking-tight text-gray-600"
      >
        Avec ce rythme : Palier {{ projectionTier.tier }} atteint (+{{
          multiplierPercentage(projectionTier.multiplicator)
        }}%)
      </h3>
    </template>
  </Block>
</template>

<script>
import { Block } from "@estaly/ui";
import { boosterThresholds, getNextTier, getReachedTier, multiplierPercentage } from "@/utils/booster";

export default {
  components: {
    Block,
  },
  props: {
    current: {
      type: Number,
      required: true,
    },
    projection: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      boosterThresholds,
    };
  },
  computed: {
    reachedTier() {
      return getReachedTier(this.current, this.boosterThresholds);
    },
    nextTier() {
      return getNextTier(this.current, this.boosterThresholds);
    },
    projectionTier() {
      return getReachedTier(this.projection, this.boosterThresholds);
    },
    statusClassBg() {
      if (this.reachedTier) return "bg-green-50";
      if (this.nextTier) return "bg-blue-50";
      return "bg-purple-50";
    },
    statusEmoji() {
      if (this.reachedTier) return "🚀";
      if (this.nextTier) return "📈";
      return "🎉";
    },
  },
  methods: {
    multiplierPercentage,
  },
};
</script>
